<div class="page-container">
  <app-navbar></app-navbar>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
